import { SAVE_CLIENT_DATA } from "./actions.types";

export const saveClientData = (data) => ({
    type: SAVE_CLIENT_DATA,
    payload: data
})